import React from "react";

export default function Billing() {
	return <div className="p-5">Billing</div>;
}
